import React, { Component } from 'react';
import axios from 'axios';
import dateFormat from 'dateformat';
import EventItem from './EventItem';
import EventDetails from './EventDetails';
import VenueFilters from './VenueFilters';
import GenreFilters from './GenreFilters';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker } from 'react-dates';
import { focusTrap, focusTrapRemove } from '../helpers/focusTrap';

/**
 * Homepage(main) Component
 *
 * Contains all state for app
 * fetchEvents() function to make api call to Ticketmaster
 * Search Filter event handling
 */
class Homepage extends Component {
   constructor(props) {
      super(props);
      // state
      this.state = {
         events: [],
         loading: true,
         error: null,
         venue: null,
         genreDefaultFilter: true,
         genres: [],
         startDate: null,
         endDate: null,
         focusedInput: null,
         selectedEvent: null,
         selectedEventImageUrl: '',
         rockFilter: false,
         popFilter: false,
         hiphopFilter: false,
         danceFilter: false,
         randbFilter: false,
         countryFilter: false,
         metalFilter: false,
         pageNumber: 0,
         totalPages: 1,
         loadMore: false,
         showLoadMore: false
      };

      this.prev = undefined;
   }
   componentDidMount() {
      // on load
      this.fetchEvents();
   }
   componentDidUpdate(prevProps) {
      if (this.state.selectedEvent != null) {
         const eventModal = document.querySelector('.event-details');
         focusTrap(eventModal);
      }
   }

   /**
     * Function to fetch events from Ticketmaster API
     */
   fetchEvents() {
      // console.log('fetch fun');
      // default pagenumber for query
      let pageNumber = 0;

      // check if loadmore
      if (!this.state.loadMore) {
         // show loader
         this.setState({
            loading: true
         });
      } else {
         // set page number parameter for query
         pageNumber = this.state.pageNumber;
      }

      // Todays Date
      const now = new Date();

      // default dates
      let startDate = dateFormat(now, 'isoUtcDateTime', true);
      let endDate = this.state.endDate;

      // convert date(s) into accepted format for API
      if (this.state.startDate) { startDate = dateFormat(this.state.startDate, 'isoUtcDateTime', true) }

      if (this.state.endDate) { endDate = dateFormat(this.state.endDate, 'isoUtcDateTime') }

      // if all genres selected
      let genreQuery = null;

      // if genres selected, join into one string
      if (this.state.genres.length > 0) {
         genreQuery = this.state.genres.join();
      }
      // api call taking in params for search
      axios({
         url: 'https://app.ticketmaster.com/discovery/v2/events.json?',
         method: 'GET',
         params: {
            apikey: 'JPIWWZkQg5Y2pgHLVUqjA3OaVmzjgG0y',
            sort: 'date,asc',
            startDateTime: startDate,
            endDateTime: endDate,
            city: 'toronto',
            venueId: this.state.venue,
            genreId: genreQuery,
            segmentId: 'KZFzniwnSyZfZ7v7nJ',
            size: '20',
            page: pageNumber
         }
      })
         // set events state with results
         .then((res) => {
            if (this.state.loadMore) {
               // add new page of results to existing events state array
               this.setState({
                  events: [...this.state.events, ...res.data._embedded.events],
                  error: null,
                  loadMore: false
               });
               //console.log(res.data._embedded.events);
            } else {
               // set events state with retrieved events
               // set totalPages state from retrieved data
               this.setState({
                  events: res.data._embedded.events,
                  totalPages: res.data.page.totalPages,
                  loading: false,
                  error: null
               });
               // console.log('total pages: ' + res.data.page.totalPages);
               // console.log(res.data._embedded.events);
            }
            // show load more button if more pages are available
            // * by 20 since pagesize is set to 20 
            // set state of showLoadMore which will allow visibility of load more button
            if ((this.state.pageNumber + 1) * 20 < this.state.totalPages * 20) {
               this.setState({
                  showLoadMore: true
               });
            } else {
               this.setState({
                  showLoadMore: false
               });
            }
         })
         .catch(err => {
            this.setState({
               loading: false,
               error: err
            });
         });
   }
   renderLoading() {
      return <div className="loading-overlay">Loading...</div>;
   }
   renderError() {
      return (
         <div className="results-error">
            <p className="results-error__copy">Sorry...there are currently no upcoming events.</p>
         </div>
      );
   }
   /**
     * Venue Selection Function
     */
   venueSelection = (e) => {
      // if all selected
      if (e.target.value === 'default') {
         this.setState({
            venue: null,
            pageNumber: 0,
            totalPages: 1
         })
      } else {
         // set venue state
         this.setState({
            venue: e.target.value,
            pageNumber: 0,
            totalPages: 1
         });
      }
   }
   /**
     *  Genre Button Selection Function
     */
   genreSelection = (e) => {
      e.preventDefault();
      // genre id
      let genreValue = e.target.value;
      // genre name
      let genreName = e.target.dataset.name + 'Filter';
      // genre state
      let genreState = this.state[genreName];
      // if "all" genre is selected
      if (this.state.genreDefaultFilter) {
         // set to false
         this.setState({
            genreDefaultFilter: false
         });
      }
      // reset pageNumber and totalPages count
      this.setState({
         pageNumber: 0,
         totalPages: 1
      });
      // if genre is not already selected
      if (!genreState) {
         // set genre state to true, add genre to array(used for api call)
         this.setState({
            [genreName]: true,
            genres: [...this.state.genres, genreValue]
         });
      }
   }

   /**
     *  Remove Genre Function
     */
   removeGenreSelection = (e) => {
      e.preventDefault();
      // genre id
      let genreValue = e.target.value;
      // genre state name
      let genreName = e.target.dataset.name + 'Filter';
      // set state to false, remove from genres array
      this.setState((prevState) => ({
         [genreName]: false,
         genres: prevState.genres.filter((genre) => {
            return genreValue !== genre;
         })
      }), () => {
         // if no genres selected, set "all" genre to true
         if (this.state.genres < 1) {
            this.setState({
               genreDefaultFilter: true
            });
         }
      });
   }
   /**
     *  Genre "All" Button Selection
     */
   genreDefaultSelection = (e) => {
      e.preventDefault();
      // if ALL is not selected
      if (!this.state.genreDefaultFilter) {
         // set all genres to false, set default to true, empty genres array
         this.setState({
            genreDefaultFilter: true,
            rockFilter: false,
            popFilter: false,
            hiphopFilter: false,
            danceFilter: false,
            randbFilter: false,
            countryFilter: false,
            metalFilter: false,
            genres: []
         });
      }
   }
   /**
     *  Event Search Function
     */
   eventSearch = (e) => {
      e.preventDefault();
      // reset pageNumber to 0
      // run fetchEvents()
      this.setState({
         pageNumber: 0
      }, () => {
         this.fetchEvents();
      });
   }
   /**
     *  Load More Function
     */
   loadMore = () => {
      this.setState({
         pageNumber: this.state.pageNumber + 1,
         loadMore: true
      }, () => {
         this.fetchEvents();
      });
   }
   /**
   * Show Event Details Modal
   * use event index to grab event in events state
   */

   showEventDetails = (e) => {
      // set selectedEvent state with selected event object
      this.setState({
         selectedEvent: this.state.events[e.target.dataset.index],
         selectedEventImageUrl: e.target.dataset.imageurl
      });
      // toggle no-scroll class on body
      // this.noScrollToggle();
      document.body.classList.add('no-scroll');

      //  this.prev = document.activeElement;
   }
   /**
   * Close Event Details Modal
   */
   closeEventDetails = () => {
      const eventModal = document.querySelector('.event-details');
      focusTrapRemove(eventModal);
      this.setState({
         selectedEvent: null
      });
      // toggle no-scroll class on body
      // this.noScrollToggle();
      document.body.classList.remove('no-scroll');
      // this.prev.focus();
      // console.log(this.prev);
   }
   eventDetailsOnKeyDown = (e) => {
      e.keyCode === 27 && this.closeEventDetails();
   }
   /**
  * Toggle no-scroll class on body to prevent scroll, for modal
  */
   noScrollToggle = () => {
      document.body.classList.toggle('no-scroll');
   }
   renderEvents() {
      if (this.state.error) {
         return this.renderError();
      }
      return (
         <div className="events">
            <div className="events__container">
               <div className="events__wrapper">

                  {this.state.events.map((event, index) => {
                     // get selected imageUrl from event images array
                     // (using imageFilter function)
                     // const imageUrl = this.imageFilter(event);

                     // below is temp for old way of having imagefilter function
                     //const imageUrl = 'test';

                     return (
                        <EventItem
                           event={event}
                           key={index}
                           index={index}
                           // imageUrl={imageUrl}
                           onClick={this.showEventDetails}
                        />
                     )
                  })}
               </div>
            </div>
            {/* showLoadMore state gets set in fetchEvents() function */}
            {(this.state.showLoadMore) ?

               <div className="load-more">
                  <button className="load-more__button" onClick={this.loadMore}>View More</button>
               </div>

               : null}

         </div>
      );
   }

   render() {
      return (
         <section className="main">
            <div className="search-filters">
               <form className="search-filters__form" onSubmit={this.eventSearch}>

                  <GenreFilters
                     genreDefaultFilter={this.state.genreDefaultFilter}
                     genreDefaultSelection={this.genreDefaultSelection}
                     genreSelection={this.genreSelection}
                     removeGenreSelection={this.removeGenreSelection}
                     rockFilter={this.state.rockFilter}
                     popFilter={this.state.popFilter}
                     hiphopFilter={this.state.hiphopFilter}
                     danceFilter={this.state.danceFilter}
                     randbFilter={this.state.randbFilter}
                     countryFilter={this.state.countryFilter}
                     metalFilter={this.state.metalFilter}
                  />

                  <div className="form-row-wrapper clearfix">

                     <VenueFilters onChange={this.venueSelection} />

                     <div className="date-filter">
                        <label htmlFor="date-filter" className="form-label">Filter By Date</label>
                        {/*Date Range Picker from react-dates */}
                        <DateRangePicker
                           startDateId="startDate"
                           endDateId="endDate"
                           startDate={this.state.startDate}
                           endDate={this.state.endDate}
                           onDatesChange={({ startDate, endDate }) => { this.setState({ startDate, endDate }) }}
                           focusedInput={this.state.focusedInput}
                           onFocusChange={(focusedInput) => {
                              this.setState({
                                 focusedInput,
                                 pageNumber: 0,
                                 totalPages: 1
                              })
                           }}
                           showClearDates={true}
                           numberOfMonths={1}
                           displayFormat="MMM D"
                           readOnly
                        />
                     </div>
                     <div className="button-wrapper">
                        <button className="search-button">Search</button>
                     </div>
                  </div>
               </form>
            </div>

            {this.state.loading ?
               this.renderLoading()
               : this.renderEvents()}

            {/* Passing selected event object, and selected event imageurl to eventdetails */}
            {this.state.selectedEvent ?
               <EventDetails
                  event={this.state.selectedEvent}
                  imageurl={this.state.selectedEventImageUrl}
                  onClick={this.closeEventDetails}
                  onKeyDown={this.eventDetailsOnKeyDown}
               />
               : null}

         </section>
      )
   }
}

export default Homepage;
